import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'

// 配置axios默认路径：按环境自动切换
// npm run dev → development → 本地;  npm run build → production → 线上
axios.defaults.baseURL = process.env.NODE_ENV === 'production'
  ? 'https://chb.bjzkbh.com/api'
  : 'http://localhost:8080/api'

// 请求拦截器：附 token
axios.interceptors.request.use(config => {
  const token = sessionStorage.getItem('token')
  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
})

// 响应拦截器：401 / token 过期 → 清本地登录态 + 跳登录页
axios.interceptors.response.use(
  response => response,
  error => {
    const status = error.response && error.response.status
    const tokenExpired = status === 401 || status === 403
    if (tokenExpired) {
      sessionStorage.removeItem('token')
      sessionStorage.removeItem('user')
      if (router.currentRoute.path !== '/login') {
        router.replace({ path: '/login', query: { redirect: router.currentRoute.fullPath } })
      }
    }
    return Promise.reject(error)
  }
)

// 将axios挂载到Vue原型上
Vue.prototype.$axios = axios

// 全局功能权限判断：超级管理员恒 true；其它账号按账号管理勾选的 funcCodes 控制
Vue.prototype.$hasPerm = function (code) {
  try {
    const user = JSON.parse(sessionStorage.getItem('user') || '{}')
    if (user && user.role === 'super_admin') return true
    const codes = JSON.parse(sessionStorage.getItem('funcCodes') || '[]')
    return Array.isArray(codes) && codes.includes(code)
  } catch (e) {
    return false
  }
}

Vue.use(ElementUI)

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')